module.exports = __webpack_public_path__ + "img/newNull.efdce021.png";